import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const ViewAllCard = ({ title, location, cardAspectSize, showFlashDealBar }) =>
  <div className={classNames('view-all-card-container viewAllCard', `viewAllCard--${cardAspectSize}`, { 'viewAllCard--flashDeals': showFlashDealBar })}>
    <Link to={`/${location}`}>
      <div className="view-all-content">
        <div className="view-all-text"><FormattedMessage id="viewAllCard.viewall" defaultMessage="View All" />&nbsp;{title}</div>
        <div className="view-all-dots">
          <div className="dot dot-color" />
          <div className="dot dot-color" />
          <div className="dot dot-color" />
        </div>
      </div>
    </Link>
  </div>;

ViewAllCard.propTypes = {
  location: PropTypes.string,
  title: PropTypes.string,
  showFlashDealBar: PropTypes.bool,
  cardAspectSize: PropTypes.oneOf([
    '',
    '16x9',
    'portrait',
    'square',
  ]),
};

ViewAllCard.defaultProps = {
  location: '',
  title: '',
  cardAspectSize: '16x9',
  showFlashDealBar: false,
};

export default ViewAllCard;
